import type { TgLinkCodeDto, TgLinkStatusDto } from '@ledokol/contracts'
import { api } from './client'

/**
 * Эпик «UI tg-link сотрудника» (T12) P1 — клиент для двух-шаговой привязки.
 *
 * api-ручки готовы с Stage 3 B5 (`apps/api/src/tg/tg-link.controller.ts`); фронт нужен
 * только сейчас (T12 — отсутствие UI). См. `docs/epic-tg-profile-link-plan.md` §3.
 *
 * Двух-шаговая защита от перехвата кода (Stage 3 §1.2):
 *   1. createCode (POST /me/tg/link) — выпускает код, TTL 15 мин.
 *   2. бот /start <код> → POST /bot/tg-link/redeem (отдельный bot-flow) → api СТЕЙДЖИТ pending.
 *   3. status (GET /me/tg/link/status) — owner кода видит «@username нажавшего» (защита).
 *   4. confirm (POST /me/tg/link/confirm) — закрепляет; внутри возможен merge stub→real (эпик O4).
 *   5. cancel (POST /me/tg/link/cancel) — аннулирует активный код/pending.
 *   6. unlink (DELETE /me/tg/link) — отвязка; задачи остаются (FK на user.id, не tg).
 */

export async function fetchTgLinkStatus(): Promise<TgLinkStatusDto> {
  const r = await api.get<TgLinkStatusDto>('/me/tg/link/status')
  return r.data
}

/** Шаг 1: получить 6-значный код (TTL 15 мин). */
export async function createTgLinkCode(): Promise<TgLinkCodeDto> {
  const r = await api.post<TgLinkCodeDto>('/me/tg/link')
  return r.data
}

/** Шаг 4: закрепить привязку после redeem'а бота. Может триггерить O4 merge stub→real. */
export async function confirmTgLink(): Promise<{ linked: true; tg_username: string | null }> {
  const r = await api.post<{ linked: true; tg_username: string | null }>('/me/tg/link/confirm')
  return r.data
}

/** Шаг 5: отменить активный код (или pending), если это не мой TG. */
export async function cancelTgLink(): Promise<void> {
  await api.post('/me/tg/link/cancel')
}

/** Шаг 6: отвязать TG. Задачи (reporter/assignee) НЕ трогаются (FK на user.id). */
export async function unlinkTg(): Promise<void> {
  await api.delete('/me/tg/link')
}
